import { BatchScopePicker } from "./BatchScopePicker";
import { AuditTab } from "./batch-detail/AuditTab";

export function AuditGlobalPage() {
  return <BatchScopePicker title="Audit">{(batch) => <AuditTab batch={batch} />}</BatchScopePicker>;
}
